import { isAppEmbedded } from '~/utils/isAppEmbedded';
import { makeRegistrationLoader, redirect } from '~/utils/routing';

export const { loader, useLoaderData } = makeRegistrationLoader(
  ({ context, params }) => {
    const {
      registrations: { isStartWarrantyClaimEnabled },
      storeUrl,
      theme,
    } = context.settings;
    // the new registration created in the previous action
    const {
      registrations: { registration },
    } = context;

    if (!registration) return redirect(`/${params.store ?? ''}`);

    if (registration.referrer && isStartWarrantyClaimEnabled)
      // todo: this should go to the new request page, but the order page has the logic
      return redirect(`../../order/${registration.orderIdFromPlatform}`);

    return {
      registration,
      storeUrl,
      isStartWarrantyClaimEnabled,
      isEmbedded: isAppEmbedded(),
      registrationSubmissionText:
        theme.registrationSubmissionText ??
        'Thank you for your registration, please keep this number for your records.',
    };
  },
);
